<template>
  <div class="main_div">
    <div style="height: auto">
      <n-space vertical>
        <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
          <n-space item-style="display: flex;" align="center">
            <div style="font-size: 20px; font-weight: bold">견적 요청 관리</div>
          </n-space>
          <div class="content_delimiter_line"></div>
          <Loading v-show="loading" />

          <n-tabs type="line" animated v-model:value="currentTab" @update:value="handleTabChange">
            <n-tab-pane :name="TAB.PENDING_REQUESTS" :disabled="listLoading">
              <template #tab>
                <n-space align="center" :size="8" :wrap-item="false">
                  <span>수신한 요청</span>
                  <n-spin v-if="listLoading && currentTab === TAB.PENDING_REQUESTS" size="small" />
                </n-space>
              </template>
              <n-space vertical style="margin-top: 10px">
                <n-space align="baseline" item-style="display: flex;">
                  <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                    <n-input-group>
                      <n-select v-model:value="searchTypeForPending" :options="searchOptions" style="width: 120px" />
                      <n-input v-model:value="searchValueForPending" placeholder="검색어를 입력하세요" clearable />
                    </n-input-group>
                  </n-form-item>
                  <n-form-item style="min-width: 300px" label-placement="left"> </n-form-item>
                  <n-form-item style="margin-bottom: 0">
                    <n-button type="primary" @click="wrappedRefreshOrders"> 조회 </n-button>
                  </n-form-item>
                </n-space>
              </n-space>
              <div v-if="listLoading && currentTab === TAB.PENDING_REQUESTS" class="loading-indicator">
                견적 요청 목록을 불러오는 중...
              </div>
              <div v-else-if="error && currentTab === TAB.PENDING_REQUESTS" class="error-message">
                {{ error }}
              </div>
              <div v-else-if="currentTab === TAB.PENDING_REQUESTS">
                <div class="table-container">
                  <n-data-table
                    v-if="orders.length > 0"
                    :columns="activeColumns"
                    :data="orders"
                    :pagination="false"
                    :bordered="true"
                  />
                  <p v-else>수신된 견적 요청이 없습니다.</p>
                </div>
                <div
                  v-if="orders.length > 0 && !listLoading && !error"
                  class="pagination-controls"
                  style="margin-top: 15px; text-align: center"
                >
                  <n-button @click="wrappedGoToPreviousPage" :disabled="currentPage === 1" style="margin-right: 8px">
                    이전 페이지
                  </n-button>
                  <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                  <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                </div>
              </div>
            </n-tab-pane>
            <n-tab-pane :name="TAB.ACCEPTED_LIST" :disabled="listLoading">
              <template #tab>
                <n-space align="center" :size="8" :wrap-item="false">
                  <span>수락된 목록</span>
                  <n-spin v-if="listLoading && currentTab === TAB.ACCEPTED_LIST" size="small" />
                </n-space>
              </template>
              <n-space vertical style="margin-top: 10px">
                <n-space align="center" item-style="display: flex;">
                  <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                    <n-input-group>
                      <n-select v-model:value="searchTypeForAccepted" :options="searchOptions" style="width: 120px" />
                      <n-input v-model:value="searchValueForAccepted" placeholder="검색어를 입력하세요" clearable />
                    </n-input-group>
                  </n-form-item>
                  <n-form-item label="수락일 기간 선택" style="min-width: 300px" label-placement="left">
                    <n-date-picker v-model:value="dateRangeForAccepted" type="daterange" clearable />
                  </n-form-item>
                  <n-form-item style="margin-bottom: 0" label-placement="left">
                    <n-button type="primary" @click="fetchAcceptedOrdersByDateRange" :disabled="!isSearchEnabled">
                      조회
                    </n-button>
                  </n-form-item>
                </n-space>
              </n-space>

              <div v-if="showAcceptedResults">
                <Loading v-show="listLoading && currentTab === TAB.ACCEPTED_LIST" />
                <div
                  v-if="!listLoading && error && currentTab === TAB.ACCEPTED_LIST"
                  class="error-message"
                  style="margin-top: 10px"
                >
                  {{ error }}
                </div>
                <n-data-table
                  v-if="!listLoading && !error && orders.length > 0 && currentTab === TAB.ACCEPTED_LIST"
                  :columns="activeColumns"
                  :data="orders"
                  :pagination="false"
                  :bordered="true"
                  style="margin-top: 10px"
                />
                <p
                  v-if="!listLoading && !error && orders.length === 0 && currentTab === TAB.ACCEPTED_LIST"
                  style="margin-top: 10px; text-align: center"
                >
                  선택된 기간에 해당하는 수락된 견적 요청이 없습니다.
                </p>
                <div
                  v-if="orders.length > 0 && !listLoading && !error"
                  class="pagination-controls"
                  style="margin-top: 15px; text-align: center"
                >
                  <n-button @click="wrappedGoToPreviousPage" :disabled="currentPage === 1" style="margin-right: 8px">
                    이전 페이지
                  </n-button>
                  <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                  <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                </div>
              </div>
              <div v-else style="margin-top: 20px; text-align: center; color: #777">조회할 기간을 선택해주세요.</div>
            </n-tab-pane>
          </n-tabs>
        </NCard>

        <n-modal
          v-model:show="showOrderDetailsModal"
          preset="card"
          style="width: 800px"
          title="견적 상세 정보"
          @after-leave="onOrderDetailsModalClose"
        >
          <div v-if="selectedOrder" class="order-details-content">
            <n-descriptions label-placement="left" bordered :column="2" size="small">
              <n-descriptions-item label="기관명">{{ selectedOrder.client.name }}</n-descriptions-item>
              <n-descriptions-item label="수신자 이메일">{{ selectedOrder.receiver_email }}</n-descriptions-item>
              <n-descriptions-item label="담당부서">{{ selectedOrder.client.dept || "N/A" }}</n-descriptions-item>
              <n-descriptions-item label="담당자">{{
                selectedOrder.client.deptPersonName || "N/A"
              }}</n-descriptions-item>
              <n-descriptions-item label="총 금액" span="2"
                >{{ selectedOrder.totalPrice.toLocaleString() }}원</n-descriptions-item
              >
              <n-descriptions-item label="상태">{{
                getQuotationStatusString(selectedOrder.status)
              }}</n-descriptions-item>
              <n-descriptions-item label="생성일">
                {{ common.getYYYYMMDD2(new Date(Number(selectedOrder.createdDate))) }}
              </n-descriptions-item>
              <n-descriptions-item label="결제 방법" :span="2">
                {{
                  selectedOrder.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.payment_method?.type || "N/A"
                }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="결제 계좌"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금자명"
                :span="2"
              >
                {{ selectedOrder.payment_method.deposit_name }}
              </n-descriptions-item>
              <n-descriptions-item
                v-if="selectedOrder.payment_method?.type === 'bank_deposit'"
                label="입금예정일"
                :span="2"
              >
                {{ selectedOrder.payment_method.bank_date }}
              </n-descriptions-item>
            </n-descriptions>

            <h4 style="margin-top: 20px; margin-bottom: 10px">견적 항목</h4>
            <n-data-table
              :columns="orderItemColumns"
              :data="selectedOrder.products"
              :pagination="false"
              :bordered="true"
              size="small"
            />

            <div style="text-align: right; margin-top: 20px">
              <n-button @click="closeOrderDetailsModal" type="tertiary" style="margin-right: 10px"> 닫기 </n-button>
              <n-button
                v-if="selectedOrder && selectedOrder.status === constant.orderStatus.PENDING"
                type="primary"
                @click="approveQuotation(selectedOrder!.SK)"
                style="margin-right: 10px"
              >
                수락 및 견적서 작성
              </n-button>
              <n-button
                v-if="selectedOrder && selectedOrder.status === constant.orderStatus.PENDING"
                type="error"
                @click="cancelQuotation(selectedOrder!.SK)"
              >
                견적 요청 거절
              </n-button>
            </div>
          </div>
        </n-modal>
      </n-space>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, computed, VNode } from "vue";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  useNotification,
  NTabs,
  NTabPane,
  NFormItem,
  NDatePicker,
  useDialog,
  NSpin,
  NInputGroup,
  NInput,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { getCallable } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { ChangeStatus } from "@/model/base";
import { Order, OrderItem } from "@/model/order"; // OrderItem 추가
import { useOrderApi } from "@/composables/useOrderForm";
import { USER_ROUTES } from "@/assets/route_constants";
import { usePagination } from "@/composables/usePagination"; // usePagination 임포트
import { useActionDialog } from "@/composables/useDialog";
import { useDownload } from "@/composables/useDownload";
import { getQuotationStatusString } from "@/composables/useOrderForm";
const { downloadQuotationFile } = useDownload();
const { show: showActionDialog } = useActionDialog();
const { deleteOrder } = useOrderApi();

const { loading } = useAuth(); // 전역 로딩 상태
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const TAB = {
  PENDING_REQUESTS: "pending",
  ACCEPTED_LIST: "accepted",
};
const currentTab = ref(TAB.PENDING_REQUESTS);
const dateRangeForAccepted = ref<[number, number] | null>(null);
const showAcceptedResults = ref(false);

const showOrderDetailsModal = ref(false);
const selectedOrder = ref<Order | null>(null);

const searchValueForPending = ref<string | null>(null);
const searchTypeForPending = ref("client.name");
const searchValueForAccepted = ref<string | null>(null);
const searchTypeForAccepted = ref("client.name");

const getOrgQuotationRequestCallable = getCallable("getOrgQuotationRequest");
const getOrgQuotationApprovedCallable = getCallable("getOrgQuotationApproved");
const orgQuotationToOrderCallable = getCallable("orgQuotationToOrder"); // 견적 확정 함수
const cancelQuotationCallable = getCallable("cancelQuotation"); // 견적 취소 함수

const searchOptions = [
  { label: "기관명", value: "client.name" },
  { label: "담당자", value: "client.deptPersonName" },
];

const isSearchEnabled = computed(() => {
  return (
    dateRangeForAccepted.value !== null || (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "")
  );
});

const activeColumns = computed(() => {
  const baseColumns = [
    { title: "기관명", key: "client.name", resizable: true },
    { title: "담당부서", key: "client.dept", resizable: true, render: (row: Order) => row.client.dept || "N/A" },
    {
      title: "담당자",
      key: "client.deptPersonName",
      resizable: true,
      render: (row: Order) => row.client.deptPersonName || "N/A",
    },
    {
      title: "총 금액", // 견적 요청 단계에서는 없을 수 있음
      key: "totalPrice",
      resizable: true,
      render: (row: Order) => (row.totalPrice ? `${row.totalPrice.toLocaleString()}원` : "N/A"),
    },
    {
      title: "상태",
      key: "status",
      resizable: true,
      render: (row: Order) => getQuotationStatusString(row.status),
    },
    {
      title: currentTab.value === TAB.PENDING_REQUESTS ? "요청일" : "수락일",
      key: "createdDate",
      resizable: true,
      render: (row: Order) => {
        if (currentTab.value === TAB.PENDING_REQUESTS) {
          const timestamp = Number(row.createdDate);
          return !isNaN(timestamp) ? common.getYYYYMMDD2(new Date(timestamp)) : row.createdDate || "N/A";
        } else {
          const timestamp = Number(row.lastUpdatedDate);
          return !isNaN(timestamp) ? common.getYYYYMMDD2(new Date(timestamp)) : row.lastUpdatedDate || "N/A";
        }
      },
    },
  ];

  if (currentTab.value === TAB.PENDING_REQUESTS) {
    return [
      ...baseColumns,
      {
        title: "작업",
        key: "actions",
        render(row: Order) {
          const actionButtons: VNode[] = [
            h(
              NButton,
              { strong: true, tertiary: true, size: "small", onClick: () => displayOrderDetails(row) },
              { default: () => "상세" }
            ),
            h(
              NButton,
              {
                style: "margin-left: 6px",
                strong: true,
                tertiary: true,
                size: "small",
                onClick: () => approveQuotation(row.SK),
                disabled: row.status !== constant.orderStatus.PENDING,
              },
              { default: () => "수락" }
            ),
            h(
              NButton,
              {
                style: "margin-left: 6px",
                strong: true,
                tertiary: true,
                size: "small",
                type: "error",
                onClick: () => cancelQuotation(row.SK),
                disabled: row.status !== constant.orderStatus.PENDING,
              },
              { default: () => "거절" }
            ),
          ];
          return actionButtons;
        },
      },
    ];
  } else {
    // TAB.ACCEPTED_LIST
    return [
      ...baseColumns,
      // { title: "수락일", key: "acceptedDate", /* ... */ }, // 수락일 정보가 있다면 추가
      {
        title: "작업",
        key: "actions",
        render(row: Order) {
          return h(
            NButton,
            { strong: true, tertiary: true, size: "small", onClick: () => displayOrderDetails(row) },
            { default: () => "상세" }
          );
        },
      },
    ];
  }
});

const orderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "단가",
    key: "unit_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.unit_price || 0).toLocaleString()}원`,
  },
  { title: "수량", key: "quantity", resizable: true },
  {
    title: "공급가액",
    key: "supply_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.supply_price || 0).toLocaleString()}원`,
  },
];

const getQuotations = async (params: any) => {
  const queryParams: any = { ...params }; // pageInfo 등 기본 파라미터 복사

  if (currentTab.value === TAB.PENDING_REQUESTS) {
    queryParams.status = constant.orderStatus.PENDING;
    return getOrgQuotationRequestCallable(queryParams);
  } else if (currentTab.value === TAB.ACCEPTED_LIST) {
    queryParams.status = constant.orderStatus.APPROVED;
    if (params.startDate && params.endDate) {
      queryParams.startDate = params.startDate;
      queryParams.endDate = params.endDate;
      return getOrgQuotationApprovedCallable(queryParams);
    } else {
      // 날짜 범위가 없으면 빈 결과를 반환 (Diagnosis.vue 참고)
      return { data: { Items: [], LastEvaluatedKey: null } };
    }
  }
};

const {
  paginatedItems: orders,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage,
  goToPreviousPage,
  refreshData,
} = usePagination<
  Order,
  { status?: string; startDate?: string; endDate?: string; searchKey?: string; searchValue?: string }
>(
  getQuotations,
  10 // 페이지 크기
);

// 전역 로딩 상태를 포함하는 래퍼 함수들
async function wrappedRefreshOrders() {
  loading.value = true;
  const searchParams: { searchKey?: string; searchValue?: string } = {};

  if (searchValueForPending.value && searchValueForPending.value.trim() !== "") {
    searchParams.searchKey = searchTypeForPending.value;
    searchParams.searchValue = searchValueForPending.value.trim();
  }
  await refreshData(searchParams);
  loading.value = false;
}

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  loading.value = true;
  await goToNextPage();
  loading.value = false;
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  loading.value = true;
  await goToPreviousPage();
  loading.value = false;
}

async function displayOrderDetails(order: Order) {
  selectedOrder.value = order;
  showOrderDetailsModal.value = true;
}

function closeOrderDetailsModal() {
  showOrderDetailsModal.value = false;
}

function onOrderDetailsModalClose() {
  selectedOrder.value = null; // 상세 정보 초기화
}

async function gotoOrderPage() {
  showActionDialog({
    title: "확인",
    content: "견적관리 화면으로 이동하시겠습니까?",
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      router.push({ name: USER_ROUTES.OrgOrder.Name });
    },
    onCancel: async () => {
      await wrappedRefreshOrders();
    },
  });
}

async function approveQuotation(quotationSK: string) {
  showActionDialog({
    title: "견적 요청 수락 및 견적서 생성",
    content: "이 견적 요청을 수락하고 견적서를 작성하시겠습니까?",
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      const payload: ChangeStatus = {
        SK: quotationSK,
        status: constant.orderStatus.APPROVED, // 수락 시 상태 변경
      };
      const result = await orgQuotationToOrderCallable(payload);
      if (common.evalFunctionResult(result)) {
        message.success("견적 요청이 성공적으로 수락되었습니다. 견적서가 생성됩니다.");
        await gotoOrderPage();
        if (showOrderDetailsModal.value) closeOrderDetailsModal();
      } else {
        message.error(common.getResultError(result) || "견적 요청 수락 중 오류가 발생했습니다.");
      }
    },
  });
}

async function cancelQuotation(orderSK: string) {
  showActionDialog({
    title: "견적 요청 거절",
    content: "이 견적 요청을 거절(삭제)하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    positiveText: "거절",
    negativeText: "취소",
    positiveButtonProps: { type: "error" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      const result = await cancelQuotationCallable({ SK: orderSK }); // cancelQuotationCallable은 SK만 받을 수 있음
      if (common.evalFunctionResult(result)) {
        message.success("견적 요청이 성공적으로 거절(삭제)되었습니다.");
        await wrappedRefreshOrders();
        if (showOrderDetailsModal.value) closeOrderDetailsModal();
      } else {
        message.error(common.getResultError(result) || "견적 요청 거절 중 오류가 발생했습니다.");
      }
    },
  });
}

async function onFileDonwload(row: Order) {
  loading.value = true;
  await downloadQuotationFile(row.quotation_pdf, row.name);
  loading.value = false;
}

async function handleTabChange(tabName: string) {
  currentTab.value = tabName;
  orders.value = []; // 탭 변경 시 목록 초기화
  error.value = null;
  if (tabName === TAB.ACCEPTED_LIST) {
    showAcceptedResults.value = false;
    dateRangeForAccepted.value = null;
    // 수락된 목록은 날짜 선택 후 조회하므로 여기서는 자동 로드 안 함
  } else {
    // "수신한 요청" 탭으로 오면 바로 조회
    await wrappedRefreshOrders();
  }
}

async function fetchAcceptedOrdersByDateRange() {
  if (!isSearchEnabled.value) {
    message.error("조회 조건을 하나 이상 입력해주세요.");
    return;
  }

  const searchParams: { startDate?: string; endDate?: string; searchKey?: string; searchValue?: string } = {};

  if (dateRangeForAccepted.value) {
    const [startTimestamp, endTimestamp] = dateRangeForAccepted.value;
    searchParams.startDate = startTimestamp.toString();
    searchParams.endDate = common.addDaysToTimestamp(endTimestamp, 1).toString();
  }

  if (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "") {
    searchParams.searchKey = searchTypeForAccepted.value;
    searchParams.searchValue = searchValueForAccepted.value.trim();
  }

  showAcceptedResults.value = false;
  await refreshData(searchParams);
  showAcceptedResults.value = true;
}

onMounted(() => {
  if (currentTab.value === TAB.PENDING_REQUESTS) {
    wrappedRefreshOrders(); // "수신한 요청" 탭의 초기 데이터 로드
  }
});
</script>

<style scope></style>
